<ion-list class="ion-no-padding">
  <bones-form-item [form]="form" [item]="item" *ngFor="let item of items"></bones-form-item>
</ion-list>
